import type * as THREE from 'three';
import { Projectile } from './Projectile';

export class ProjectilePool {
  readonly pool: readonly Projectile[];

  constructor(parent: THREE.Object3D, max = 48) {
    const pool: Projectile[] = [];
    for (let i = 0; i < max; i++) {
      const p = new Projectile();
      parent.add(p.object3D);
      pool.push(p);
    }
    this.pool = pool;
  }

  spawn(
    worldPos: THREE.Vector3,
    velocity: THREE.Vector3,
    damage: number
  ): Projectile | null {
    for (const p of this.pool) {
      if (!p.active) {
        p.spawn(worldPos, velocity, damage);
        return p;
      }
    }
    return null;
  }

  update(dt: number): void {
    for (const p of this.pool) {
      if (p.active) p.update(dt);
    }
  }

  dispose(): void {
    for (const p of this.pool) p.dispose();
  }
}
